//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "@/utils/common.js";
import regionSeatLibs from "utils/regionSeatLibs";
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c));

export default {
  name: "SupplyManageList",
  data() {
    return {
      filterForm: {
        name: "",
        contactName: "",
        // businessZoneId: '', //服务区域id
        userName: "",
        // pageType: 5,
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
      businessZoneList: [], //服务区域数据
      zoneProps: {
        value: "id",
        label: "zoneName",
        children: "children",
      },
      checkedZone: [], //选中的服务区域
      dutyPersonList: [],
      dialogResetVisible: false,
      currentData: {},
      resetRules: {
        userPassword: [
          { required: true, message: "请填写6-20位账号密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "请输入6-20位账号密码",
            trigger: "blur",
          },
        ],
      },
      dialogUpdateVisible: false,
      currentCheckedZone: [],
      updateRules: {
        contactName: [
          { required: true, message: "请填写联系人名称", trigger: "blur" },
        ],
        contactMobile: [
          { required: true, message: "请填写手机号码", trigger: "blur" },
          { validator: common.checkMobile, required: true, trigger: "blur" },
        ],
        subDomain: [
          { required: true, message: "请填写登录地址", trigger: "blur" },
          { trigger: "blur", validator: common.checkSubDomain },
          { min: 2, max: 20, message: "长度在4到20位", trigger: "blur" },
        ],
        businessZoneId: [
          { required: true, message: "请选择服务区域", trigger: "blur" },
        ],
      },
      oldRowData: {},
      checkedRegionData: [],
      regionProps: {
        value: "i",
        label: "n",
        children: "c",
      },
      regionData,
    };
  },
  components: {},
  watch: {
    checkedZone(newVal) {
      this.dutyPersonList = [];
      this.filterForm.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      newVal.length > 0 && this.getDutyPerson();
    },
    currentCheckedZone(newVal) {
      this.dutyPersonList = [];
      this.currentData.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      // newVal.length > 0 && this.getCurrentDutyPerson();
    },
  },
  created() {
    this.getBusinessZoneData();
    this.getSupplyMarketList();
  },
  mounted() {},
  methods: {
    // 下拉补贴地区选完关闭
    handleRegionChange(val) {
      this.$refs.regionCascader.dropDownVisible = false;
      let _params = this.filterForm;
      _params.provinceId = val[0] || "";
      _params.cityId = val[1] || "";
      _params.countyId = val[2] || "";
    },
    //页码切换
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getSupplyMarketList();
    },
    /**
     * @Description: 获取系统列表
     * @return {*}
     */
    async getSupplyMarketList() {
      try {
        let { data } = await this.$http.supply.getSupplyMarketList({
          ...this.pagination,
          ...this.filterForm,
        });
        let myData = data.content;
        myData.forEach((item) => {
          if (item.ddCoop !== null) {
            let ddCoop = item.ddCoop;
            item.name = ddCoop.name;
            item.contactName = ddCoop.contactName;
            item.contactMobile = ddCoop.contactMobile;
          }
        });
        this.$set(this, "tableData", myData);
        this.pagination.total = data.recordTotal;
      } catch (error) {
        console.log(error);
      }
    },
    // 获取服务区域数据
    getBusinessZoneData() {
      this.$http.common.getBusinessZoneList({}).then((res) => {
        this.businessZoneList = res.data;
      });
    },
    // 获取业务负责人
    getDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.filterForm.businessZoneId })
        .then((res) => {
          this.dutyPersonList = res.data;
        });
    },
    // 查询
    handleFilter() {
      this.pagination.currentPage = 1;
      this.getSupplyMarketList();
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields();
      this.checkedRegionData = [];
      let _filterForm = this.filterForm;
      _filterForm.provinceId = "";
      _filterForm.cityId = "";
      _filterForm.countyId = "";
      setTimeout(() => {
        this.handleFilter();
      }, 500);
    },
    /**
     * @Description: 停用/启用
     * @param {*} handleStatus
     */
    async handleStatus(row, e) {
      let isEnable = row.isEnable == 0 ? 1 : 0;
      let isEnableName = isEnable == 1 ? "启用" : "停用";
      let { id } = row;
      let target = e.target;
      if (target.nodeName == "SPAN") {
        target = e.target.parentNode;
      }
      target.blur();
      if (isEnable == 0) {
        this.$confirm(
          `是否确认${isEnableName}该账号？`,
          `${isEnableName}提示`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.updateStatus({ userId: id, isEnable });
          })
          .catch(() => {});
      } else {
        this.updateStatus({ userId: id, isEnable });
      }
    },
    /**
     * @Description: 启用停用服务
     * @param {*} params
     */
    async updateStatus(params) {
      try {
        let { status, data } = await this.$http.supply.userEnable(params);
        if (status == 1) {
          this.$message.success(
            params.isEnable == 1 ? "当前账号已启用" : "当前账号已停用"
          );
          this.getSupplyMarketList();
        }
        // else {
        //     this.$message.error(
        //         params.isEnable == 1 ? '当前账号未启用' : '当前账号未停用'
        //     );
        // }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @Description: 打开弹窗
     * @param {*} row 当前数据
     * @param {*} type 弹窗类型
     * @return {*}
     */
    handleInfo(row, type) {
      this.currentData = JSON.parse(JSON.stringify(row));
      // this.currentData.address = `${row.provinceName}>${row.cityName}>${row.areaName
      //     }`;
      switch (type) {
        case "update":
          // this.getFinanceAccountDetail(
          //     this.currentData.id,
          //     `${row.provinceName}>${row.cityName}>${row.areaName}`
          // );
          this.dialogUpdateVisible = true;
          break;
        case "reset":
          this.dialogResetVisible = true;
          break;
        default:
          break;
      }
    },
    /**
     * @Description: 重置密码
     */
    handleResetInfo(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let { id, userPassword } = this.currentData;
          try {
            let { status } = await this.$http.supply.updatePwd({
              userId: id,
              password: userPassword,
            });
            if (status == 1) {
              this.$message.success("当前账号重置密码成功");
              this.dialogResetVisible = false;
            }
          } catch (error) {
            console.log(error);
          }
        } else {
        }
      });
    },
    /**
     * @Description: 获取账号详情
     */
    async getFinanceAccountDetail(id, address) {
      try {
        let { data } = await this.$http.bank.getFinanceAccountDetail({ id });
        this.currentData = data;
        this.currentData.address = address;
        this.dialogUpdateVisible = true;
      } catch (error) {}
    },
    /**
     * @Description: 保存县账号更新信息
     * @param {*} formName 表单名称
     */
    handleSaveInfo(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let { id, contactMobile, contactName, name } = this.currentData;
          try {
            let { status } = await this.$http.supply.userEdit({
              userId: id,
              phone: contactMobile,
              contactName,
              name,
            });
            if (status == 1) {
              this.$message.success("当前县账号修改成功");
              this.dialogUpdateVisible = false;
              this.getSupplyMarketList();
            }
          } catch (error) {
            console.log(error);
          }
        } else {
        }
      });
    },
    // 供销社
    bankAssociate(key, cb) {
      if (key !== "") {
        this.loading = true;
        this.$http.bank
          .fuzzyQueryList({ key })
          .then(({ data }) => {
            this.loading = false;
            let arr = data.map((item, index) => ({ name: item, value: index }));
            cb(arr); // 渲染回调
          })
          .catch((res) => {
            this.loading = false;
          });
      }
    },
  },
};
